// extracted by mini-css-extract-plugin
export default {"root":"_1FdV1","subscription-center":"_1RHcD","subscriptionCenter":"_1RHcD"};